import { RunIdentityDeps, RunIdentityResult } from '../types';

/**
 * Fetch the user profile and autodesk context concurrently.
 * These two Forge calls are independent; running them in parallel removes the
 * serial penalty that delayed LaunchDarkly initialization.
 */
export const runIdentity = async ({
	fetchUserProfile,
	fetchAutodeskContext,
}: RunIdentityDeps): Promise<RunIdentityResult> => {
	const [userProfile, autodeskUserContext] = await Promise.all([
		fetchUserProfile(),
		fetchAutodeskContext(),
	]);
	return { userProfile, autodeskUserContext };
};
